import React, { useState } from 'react';
import { darkTheme } from './darkTheme';
import { mainTheme } from './mainTheme';

export const ThemeContext = React.createContext({
  theme: mainTheme,
  changeTheme: null,
});

export const ThemeContextProvider = ({ children }) => {
  const [theme, setTheme] = useState(mainTheme);
  const [isDarkSelected, setIsDarkSelected] = useState(true);
  const provider = {
    theme,
    changeTheme: () => {
      const newTheme = isDarkSelected ? darkTheme : mainTheme;
      setTheme(newTheme);
      setIsDarkSelected(!isDarkSelected);
    },
  };

  return (
    <ThemeContext.Provider value={provider}>{children}</ThemeContext.Provider>
  );
};
